import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Distributor = styled.div`
  padding: 10px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InfoText = styled.p`
  margin-top: 4px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.neutral.gray7};
`;
